const content: { [key: string]: any } = {
  userDelegationList: 'User Delegations',
};

export default content;
